import React from 'react';
import { IconArrowRight } from '../icons';
import { stopEvent } from './util';
import './search.css';

// The link between two song chips: "and" (both in the show) or an arrow
// (the first song played into the next one). Click toggles.
// Optional: `disabled` + `disabledReason` when linking would pass a server cap.
export default function ChipConnector({ linked, onToggle, disabled, disabledReason }) {
  const title = disabled && !linked ? disabledReason || 'Played into the next song' : 'Played into the next song';
  return (
    <button
      type="button"
      className={'ss-conn' + (linked ? ' linked' : '')}
      aria-pressed={!!linked}
      aria-label={linked ? 'into, click to change to and' : 'and, click to change to into'}
      title={title}
      disabled={!!disabled && !linked}
      onMouseDown={stopEvent}
      onTouchEnd={stopEvent}
      onKeyDown={stopEvent}
      onClick={(e) => {
        e.stopPropagation();
        onToggle && onToggle();
      }}
    >
      {linked ? <IconArrowRight size={14} /> : <span className="ss-conn-and">and</span>}
    </button>
  );
}
